<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_items" autocomplete="off">
                <v-layout row wrap>
                    

                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_total_review" type="number"
                            :label="$store.getters.lang.data.item_total_review" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_name" type="text" :label="$store.getters.lang.data.item_name"
                            outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <v-flex xs12 lg6 xl6 md12 sm12>
                        <v-textarea rows="1" auto-grow v-model="items.item_description" type="text"
                            :label="$store.getters.lang.data.item_description" outlined class="mx-1" filled required rounded>
                        </v-textarea>
                    </v-flex>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="towns" v-model="items.town_id" outlined
                            item-text="town_full_name" item-value="town_id" :return-object="false"
                            :label="$store.getters.lang.data.town_name">
                        </v-select>
                    </v-flex>

                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="categories" v-model="items.category_id"
                            outlined item-text="category_name" item-value="category_id" :return-object="false"
                            :label="$store.getters.lang.data.category_name">
                        </v-select>
                    </v-flex>


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_image" type="text"
                            :label="$store.getters.lang.data.item_image" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <v-flex xs12 lg4 xl4 md6 sm12>
                        <v-text-field v-model="items.item_location" type="text"
                            :label="$store.getters.lang.data.item_location" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_lat" type="number" :label="$store.getters.lang.data.item_lat"
                            outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_long" type="number"
                            :label="$store.getters.lang.data.item_long" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_keywords" type="text"
                            :label="$store.getters.lang.data.item_keywords" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="items.item_status" type="text"
                            :label="$store.getters.lang.data.item_status" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="users" v-model="items.user_id" outlined
                            item-text="user_id" item-value="user_id" :return-object="false"
                            :label="$store.getters.lang.data.user_id">
                        </v-select>
                    </v-flex> -->

                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}} item
                        </v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-text primary-title>
                            <v-layout row wrap mx-2>
                                <v-flex xs12 lg6 md6 xl6 sm6>
                                    {{$store.getters.lang.data.items}}
                                    <br>
                                    <v-switch label="Only Pending" v-model="only_pending"></v-switch>
                                </v-flex>
                                <v-flex xs12 lg6 md6 xl6 sm6>
                                    <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="item_id">
                                <template v-slot:[`item.item_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_items(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/items-list/'+item.item_id" icon color="secondary" class="mx-1"
                                            rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <template v-slot:[`item.item_name`]="{ item }">
                                    <div>
                                        <v-icon size="10" v-if="item.item_status == 'disable'" color="red">fas fa-circle</v-icon>
                                        <v-icon size="10" v-else-if="item.item_status == 'enable'" color="green">fas fa-circle</v-icon>
                                        <v-icon size="10" v-else-if="item.item_status == 'pending'" color="orange">fas fa-circle</v-icon>
                                        {{item.item_name}}
                                    </div>
                                </template>
                                <template v-slot:[`item.item_is_open`]="{ item }">
                                    <div>
                                        <span  v-if="item.item_is_open == 'qfl'" >🔒</span>
                                        <span v-else-if="item.item_is_open == 'open'" >💬</span>
                                    </div>
                                </template>
                                <template v-slot:[`item.avg_rate`]="{ item }">
                                    <div>
                                        ⭐
                                        {{item.avg_rate}} 
                                    </div>
                                </template>
                                <template v-slot:[`item.item_total_fav`]="{ item }">
                                    <div>
                                        ❤️
                                        {{item.item_total_fav}} 
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_items(selected_items.item_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/items'
    export default {
        data() {
            return {
                items: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_items: {},
                delete_dialog: false,
                headers: [

                     {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'item_custom_sort',
                    },
                     {
                        text: this.$store.getters.lang.data.item_name,
                        align: 'start',
                        sortable: true,
                        value: 'item_name',
                    },


                    // {
                    //     text: this.$store.getters.lang.data.item_description,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_description',
                    // },


                    {
                        text: this.$store.getters.lang.data.town_name,
                        align: 'start',
                        sortable: true,
                        value: 'town_full_name',
                    },
                    {
                        text: this.$store.getters.lang.data.item_location,
                        align: 'start',
                        sortable: true,
                        value: 'item_location',
                    },


                    {
                        text: this.$store.getters.lang.data.category_name,
                        align: 'start',
                        sortable: true,
                        value: 'category_name',
                    },


                    {
                        text: '⭐',
                        align: 'start',
                        sortable: true,
                        value: 'avg_rate',
                    },
                    {
                        text: '❤️',
                        align: 'start',
                        sortable: true,
                        value: 'item_total_fav',
                    },
                    {
                        text: '💬',
                        align: 'start',
                        sortable: true,
                        value: 'item_is_open',
                    },


                   


                    // {
                    //     text: this.$store.getters.lang.data.item_image,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_image',
                    // },


                    


                    // {
                    //     text: this.$store.getters.lang.data.item_lat,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_lat',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.item_long,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_long',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.item_keywords,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_keywords',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.item_status,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_status',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.user_id,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'user_id',
                    // },
                    {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'item_id',
                    },


                ],
                only_pending: false,
            }
        },
        computed: {
            rows() {
                let items = this.$store.getters?.items
                if (this.only_pending) {
                    items = items?.filter(item => item.item_status == 'pending')
                }
                if (this.$route.query.category_id) {
                    items = items?.filter(item => item.category_id == this.$route.query.category_id)   
                }
                return items
            },
            categories() {
                return this.$store.getters.categories
            },
            towns() {
                return this.$store.getters.towns
            },
            users() {
                return this.$store.getters.users
            },
        },
        mounted() {
            this.read_items();
        },
        methods: {
            add_items() {
                controller.add_items(this.items).then(r => {
                    if (r.data) {
                        this.items = {}
                        this.$store.state.items.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'items Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add items',
                            color: 'error'
                        }
                    }
                })
            },
            delete_items(item_id) {
                controller.delete_items(item_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.items = this.$store.state.items.filter(f => {
                            return f.item_id != item_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'items Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_items() {
                this.loading = true
                controller.get_items().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_items(i) {
                this.selected_items = i
                this.delete_dialog = true
            },
        },
    }
</script>